import React from "react";
const initial = {
    extend: null,
    updateExtend: () => { },
};
export const xExtendContext = React.createContext(initial);
export const yExtendContext = React.createContext(initial);
export const y2ExtendContext = React.createContext(initial);
export const ExtendContextProvider = ({ initialData, extendContext, children, }) => {
    const [extend, setExtend] = React.useState(initialData);
    React.useEffect(() => {
        setExtend(initialData);
    }, [initialData]);
    const updateExtend = React.useCallback((xExtend) => {
        setExtend(xExtend);
    }, [extend]);
    const value = {
        extend: extend,
        updateExtend,
    };
    return (React.createElement(extendContext.Provider, { value: value }, children));
};
export const ExtendHandler = ({ children, hasXProvider, hasYprovider }) => {
    if (hasXProvider && !hasYprovider) {
        return (React.createElement(ExtendContextProvider, { initialData: null, extendContext: xExtendContext }, children));
    }
    else if (!hasXProvider && hasYprovider) {
        return (React.createElement(ExtendContextProvider, { initialData: null, extendContext: yExtendContext }, children));
    }
    else {
        return (React.createElement(ExtendContextProvider, { initialData: null, extendContext: xExtendContext },
            React.createElement(ExtendContextProvider, { initialData: null, extendContext: yExtendContext },
                React.createElement(ExtendContextProvider, { initialData: null, extendContext: y2ExtendContext }, children))));
    }
};
//# sourceMappingURL=index.js.map